import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ForceErrorsDAO {
  private readonly FORCE_ERRORS_KEY = "forceErrors";

  isEnabled(): boolean {
    return window.localStorage.getItem(this.FORCE_ERRORS_KEY) === "true";
  }

  setEnabled(enabled: boolean): void {
    window.localStorage.setItem(
      this.FORCE_ERRORS_KEY,
      enabled ? "true" : "false"
    );
  }
}
